import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import { showRecruitmentPageHeading } from '../../../services/recruitments';
import { RecruitmentImage, Variant } from '../../../types/recruitments';

type Props = {
  recruitmentId: number;
  noimage: string;
};

export const Component: FunctionComponent<Props> = ({
  recruitmentId,
  noimage,
}) => {
  const [images, setImages] = useState<RecruitmentImage[]>([]);
  const [recruitmentTitle, setRecruitmentTitle] = useState('');
  const [isScouted, setIsScouted] = useState(false);
  const [isApplied, setIsApplied] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [regularEmployee, setRegularEmployee] = useState(false);

  useEffect(() => {
    const request = async () => {
      try {
        const response = await showRecruitmentPageHeading(recruitmentId);
        setImages(response.images);
        setRecruitmentTitle(response.recruitment_title);
        setIsScouted(response.isScouted);
        setIsApplied(response.isApplied);
        setIsNew(response.isNew);
        setRegularEmployee(response.regularEmployee);
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, []);

  return (
    <Presentation
      images={images}
      recruitmentTitle={recruitmentTitle}
      isScouted={isScouted}
      isApplied={isApplied}
      isNew={isNew}
      regularEmployee={regularEmployee}
      noimage={noimage}
    />
  );
};
